import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e042f8f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "value", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "space"
}

import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ApRadio',
  props: {
        name: { type: String },
        value: { type: [String, Number, Boolean], required: true },
        modelValue: { type: [String, Number, Boolean] },
        label: { type: String, required: false },
        theme: { type: String, default: 'green' },
        disabled: { default: false },
        clearOnSelectAgain: {
            type: Boolean,
            default: false,
        },
    },
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props;

    
    

    const isChecked = computed(() => props.modelValue == props.value);

    function updateInput() {
        if (isChecked.value) {
            if (props.clearOnSelectAgain) {
                emutUpdate(null);
            }
            return;
        }
        emutUpdate(props.value);
    }

    function emutUpdate(newValue: string | number | boolean | null) {
        emit('change', newValue);
        emit('update:modelValue', newValue);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["ap-radio by-checked", ['theme-' + __props.theme, __props.disabled ? 'disabled' : '']])
  }, [
    _createElementVNode("input", {
      class: "radio",
      type: "radio",
      checked: isChecked.value,
      value: __props.value,
      onInput: updateInput,
      disabled: __props.disabled
    }, null, 40, _hoisted_1),
    _createElementVNode("i", {
      class: _normalizeClass(["ap-checkmark", { checked: isChecked.value }])
    }, null, 2),
    (__props.label || _ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ])
  ], 2))
}
}

})